import src from "IMAGE";
export default { src, width: 464, height: 128, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAO0lEQVR42m3IIRIAEBAF0L87Y4yicIRNBGGr5BKiY8hujhnRiw94rGE7R1pZQsUPE7iI16axE8Gdovsbh8UDuvJ7ef8AAAAASUVORK5CYII="};
